var map = {
	"./Global": 45,
	"./Global.jsx": 45,
	"./all_page/inAllPage": 148,
	"./all_page/inAllPage.jsx": 148,
	"./appliances/AddAppliance": 86,
	"./appliances/AddAppliance.jsx": 86,
	"./appliances/Appliance": 69,
	"./appliances/Appliance.jsx": 69,
	"./appliances/Appliance.module": 18,
	"./appliances/Appliance.module.scss": 18,
	"./appliances/ApplianceForm": 87,
	"./appliances/ApplianceForm.jsx": 87,
	"./appliances/ApplianceList": 149,
	"./appliances/ApplianceList.jsx": 149,
	"./appliances/AsList": 150,
	"./appliances/AsList.jsx": 150,
	"./battery/Battery": 31,
	"./battery/Battery.module": 31,
	"./battery/Battery.module.scss": 31,
	"./battery/BatteryLevel": 38,
	"./battery/BatteryLevel.jsx": 38,
	"./departments/Department": 70,
	"./departments/Department.jsx": 70,
	"./departments/Department.module": 39,
	"./departments/Department.module.scss": 39,
	"./departments/DepartmentForm": 88,
	"./departments/DepartmentForm.jsx": 88,
	"./departments/DepartmentList": 151,
	"./departments/DepartmentList.jsx": 151,
	"./doctors/AddDoctor": 89,
	"./doctors/AddDoctor.jsx": 89,
	"./doctors/Doctor": 71,
	"./doctors/Doctor.jsx": 71,
	"./doctors/Doctor.module": 17,
	"./doctors/Doctor.module.scss": 17,
	"./doctors/DoctorForm": 90,
	"./doctors/DoctorForm.jsx": 90,
	"./doctors/DoctorList": 152,
	"./doctors/DoctorList.jsx": 152,
	"./elements/CustomSlider": 49,
	"./elements/CustomSlider.jsx": 49,
	"./elements/CustomSliderWards": 60,
	"./elements/CustomSliderWards.jsx": 60,
	"./filters/MonoFilters": 136,
	"./filters/MonoFilters.jsx": 136,
	"./filters/MonoFilters.module": 85,
	"./filters/MonoFilters.module.scss": 85,
	"./filters/MonoFiltersSmall": 179,
	"./filters/MonoFiltersSmall.jsx": 179,
	"./indicators/Indicator": 91,
	"./indicators/Indicator.jsx": 91,
	"./indicators/IndicatorForm": 92,
	"./indicators/IndicatorForm.jsx": 92,
	"./indicators/Indicators": 30,
	"./indicators/Indicators.module": 30,
	"./indicators/Indicators.module.scss": 30,
	"./indicators/IndicatorsInfo": 180,
	"./indicators/IndicatorsInfo.jsx": 180,
	"./indicators/IndicatorsInfoCopy": 93,
	"./indicators/IndicatorsInfoCopy.jsx": 93,
	"./indicators/IndicatorsList": 181,
	"./indicators/IndicatorsList.jsx": 181,
	"./layouts/ConfirmRoles": 182,
	"./layouts/ConfirmRoles.jsx": 182,
	"./layouts/Profile": 72,
	"./layouts/Profile.jsx": 72,
	"./layouts/Profile.module": 7,
	"./layouts/Profile.module.scss": 7,
	"./layouts/ProfileForm": 94,
	"./layouts/ProfileForm.jsx": 94,
	"./layouts/ProfileMain": 183,
	"./layouts/ProfileMain.jsx": 183,
	"./layouts/ProfilePatient": 95,
	"./layouts/ProfilePatient.jsx": 95,
	"./layouts/ProfilePatientForm": 96,
	"./layouts/ProfilePatientForm.jsx": 96,
	"./layouts/ProfilePatientMain": 228,
	"./layouts/ProfilePatientMain.jsx": 228,
	"./layouts/WidgetList": 243,
	"./layouts/WidgetList.jsx": 243,
	"./layouts/WidgetListHeader": 230,
	"./layouts/WidgetListHeader.jsx": 230,
	"./layouts/roles": 231,
	"./layouts/roles.jsx": 231,
	"./loaded/Loader": 137,
	"./loaded/Loader.module": 137,
	"./loaded/Loader.module.scss": 137,
	"./loaded/PageIsLoaded": 232,
	"./loaded/PageIsLoaded.jsx": 232,
	"./menu/MenuList": 138,
	"./menu/MenuList.jsx": 138,
	"./menu/MenuList.module": 37,
	"./menu/MenuList.module.scss": 37,
	"./patients/AddPatient": 104,
	"./patients/AddPatient.jsx": 104,
	"./patients/Patient": 73,
	"./patients/Patient.jsx": 73,
	"./patients/Patient.module": 20,
	"./patients/Patient.module.scss": 20,
	"./patients/PatientForm": 105,
	"./patients/PatientForm.jsx": 105,
	"./patients/PatientList": 233,
	"./patients/PatientList.jsx": 233,
	"./position/AddPositionSector": 106,
	"./position/AddPositionSector.jsx": 106,
	"./position/CirclePosition": 107,
	"./position/CirclePosition.jsx": 107,
	"./position/DinamicGraphPosition": 108,
	"./position/DinamicGraphPosition.jsx": 108,
	"./position/DinamicGraphPositionFilters": 234,
	"./position/DinamicGraphPositionFilters.jsx": 234,
	"./position/DinamicGraphPositionWards": 235,
	"./position/DinamicGraphPositionWards.jsx": 235,
	"./position/ManSad": 140,
	"./position/ManSad.jsx": 140,
	"./position/ManSmiley": 139,
	"./position/ManSmiley.jsx": 139,
	"./position/MiniMap": 55,
	"./position/MiniMap.jsx": 55,
	"./position/MiniMapClear": 109,
	"./position/MiniMapClear.jsx": 109,
	"./position/Position": 9,
	"./position/Position.module": 9,
	"./position/Position.module.scss": 9,
	"./position/PositionSector": 110,
	"./position/PositionSector.jsx": 110,
	"./position/PositionSectorForm": 111,
	"./position/PositionSectorForm.jsx": 111,
	"./position/PositionSectorList": 236,
	"./position/PositionSectorList.jsx": 236,
	"./search/Search": 141,
	"./search/Search.jsx": 141,
	"./search/Search.module": 19,
	"./search/Search.module.scss": 19,
	"./tests/Test": 142,
	"./tests/Test.jsx": 142,
	"./tests/Test.module": 112,
	"./tests/Test.module.scss": 112,
	"./ward/BlackWard": 16,
	"./ward/BlackWard.module": 16,
	"./ward/BlackWard.module.scss": 16,
	"./ward/DinamicGraphList": 237,
	"./ward/DinamicGraphList.jsx": 237,
	"./ward/DinamicGraphic": 78,
	"./ward/DinamicGraphic.jsx": 78,
	"./ward/DinamicGraphicBlack": 77,
	"./ward/DinamicGraphicBlack.jsx": 77,
	"./ward/DinamicGraphicItem": 113,
	"./ward/DinamicGraphicItem.jsx": 113,
	"./ward/DinamicWard": 74,
	"./ward/DinamicWard.jsx": 74,
	"./ward/DinamicWard.module": 13,
	"./ward/DinamicWard.module.scss": 13,
	"./ward/DinamicWardList": 238,
	"./ward/DinamicWardList.jsx": 238,
	"./wards/Graphic": 114,
	"./wards/Graphic.jsx": 114,
	"./wards/Ward": 75,
	"./wards/Ward.jsx": 75,
	"./wards/Ward.module": 21,
	"./wards/Ward.module.scss": 21,
	"./wards/WardList": 239,
	"./wards/WardList.jsx": 239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;